import {createClasses} from '@minimal/theme/create-classes';

// ----------------------------------------------------------------------

export const faClasses = {
  root: createClasses('fontawesome__root'),
};
